var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 2.82664C7.05889 2.71923 7.52871 2.66554 8 2.66664C12.6667 2.66664 15.3333 7.99998 15.3333 7.99998C14.9287 8.75705 14.446 9.4698 13.8933 10.1266M9.41333 9.41331C9.23024 9.60981 9.00943 9.76741 8.7641 9.87673C8.51877 9.98604 8.25394 10.0448 7.98539 10.0496C7.71685 10.0543 7.45011 10.0049 7.20107 9.9043C6.95204 9.80371 6.72582 9.654 6.5359 9.46408C6.34598 9.27416 6.19626 9.04794 6.09567 8.7989C5.99508 8.54987 5.94569 8.28312 5.95042 8.01458C5.95516 7.74604 6.01394 7.48121 6.12325 7.23587C6.23256 6.99054 6.39017 6.76974 6.58667 6.58664M11.96 11.96C10.8204 12.8286 9.43274 13.3099 8 13.3333C3.33333 13.3333 0.666668 7.99998 0.666668 7.99998C1.49593 6.45457 2.64609 5.10438 4.04 4.03998L11.96 11.96Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666668 0.666626L15.3333 15.3333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLock);
export default __webpack_public_path__ + "static/media/EyeLock.d72ae5c857dbb39becd8c6bb84f02689.svg";
export { ForwardRef as ReactComponent };